<template>
  <div class="top-performer">
    <div class="top-performer__header">
      <h2 data-qa-id="top-performer-title" class="mt-e-title mt-e-title--header">
        {{ $t('pages.dashboard.components.top_performing_families.title') }}
      </h2>
    </div>
    <div
      v-for="topPerformer in topPerformers"
      :key="topPerformer.familyName"
      data-qa-id="top-performer-list"
      class="top-performer__list"
    >
      <span
        data-qa-id="top-performer-list-name"
        class="top-performer__list__name"
      >{{ topPerformer.familyName }}</span>
      <div class="top-performer__list__right-part">
        <span 
          data-qa-id="top-performer-list-order-quantity"
          class="top-performer__list--orders"
        >
          {{
            $t('pages.dashboard.components.top_performing_families.order_quantity', { orderQuantity: topPerformer.orderQuantity })
          }}</span>
        <span
          data-qa-id="top-performer-list-amount"
          class="top-performer__list--amount"
        >
          <strong>
            {{ topPerformer.saleAmount }}
          </strong>
        </span>
      </div>
      <span
        data-qa-id="top-performer-list-width"
        class="top-performer__list__bar"
        :style="{width: topPerformer.width}"
      />
    </div>
  </div>
</template>
<script src="./script.js" />
